export const SystemControls = ({ stage = 0 }) => {
  const gl = useThree((state) => state.gl);

  useEffect(() => {
    const handleClick = (evt) => {
      const player = players.entities[0];
      if (player.stop) return;

      if (!player.isJumping) {
        player.velocity.y = beerConfig.player.jumpForce;
        // player.isJumping = true;
        console.log('SystemControls.add jumping');
        ECS.world.addComponent(player, 'isJumping', true);
      }
    };

    const canvasEl = gl.domElement;
    canvasEl.addEventListener('click', handleClick);

    return () => {
      canvasEl.removeEventListener('click', handleClick);
    };
  }, []);

  useFrame((state, delta) => {
    const area = beerConfig.areas[stage];
    const speed = area.speed;
    const acceleration = beerConfig.player.acceleration * speed;
    const maxVelocity = beerConfig.player.maxVelocity * speed;

    for (const entity of players) {
      entity.velocity.x += acceleration * delta;
      if (entity.velocity.x > maxVelocity) {
        entity.velocity.x = maxVelocity;
      }
    }
  });

  return null;
};
